import { useCallback, useEffect } from 'react';
import Page from '../../../components/page/Page';
import Header from '../../../components/companies/Header';
import { useCompanyCore } from '../../../../core/modules/company';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { Avatar, Paper, Typography } from '@mui/material';
import { useNavigationCore } from '../../../../core/router/navigation';
import CompanyDialog from '../../../components/companies/CompanyDialog';
import { Company } from '../../../../core/interfaces/company.interface';
import { useMeCore } from '../../../../core/modules/me';

const Companies = () => {
  const { user } = useMeCore();
  const { companies, options, getCompanies } = useCompanyCore();
  const { goToCompany, goToWelcome } = useNavigationCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (!user?.is_superuser) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    getCompanies(options);
  }, [getCompanies, options]);

  const onSelecting = useCallback((id: string) => {
    goToCompany(id);
  }, [goToCompany]);

  return (
    <>
      <Page
        header={<Header />}
        content={
          !companies.length ? (
            <div className="flex flex-1 items-center justify-center h-full">
              <Typography color="text.secondary" variant="h5">
                No hay compañías
              </Typography>
            </div>
          ) : (
            <div className="w-full my-16 sm:col-span-3 px-24 md:px-32">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-24 w-full min-w-0">
                {companies.map((company: Company) => (
                  <Paper
                    className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden cursor-pointer"
                    key={company.id}
                    onClick={() => onSelecting(company.id)}
                  >
                    <div className="flex flex-col flex-auto w-full p-32 items-center text-center">
                      {company?.selectedAvatar ? (
                        <Avatar className="w-112 h-112" src={company.selectedAvatar}></Avatar>
                      ) : (
                        <Avatar className="w-112 h-112">
                          {company?.name[0]}
                        </Avatar>
                      )}
                      <Typography className="font-medium">
                        {company.name}
                      </Typography>
                    </div>
                  </Paper>
                ))}
              </div>
            </div>
          )
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CompanyDialog />
    </>
  );
};

export default Companies;
